import * as React from "react"
//import Introduction from "../introduction"
import EducationValue from "../education-value"
import CooperationModel from "../cooperation-model"
import CooperationFlow from "../cooperation-flow"
import ContactUs from "../contact-us"
import RecentNews from "../recent-news"
import EducationStory from "@/components/education/education-story"
import Banner from "@/components/courses-catalog/banner";

const CampusEnterpriseCooperation: React.FC<
  CampusEnterpriseCooperation & { location: ILocation }
> = props => {
  const {
    pageType,
    //introductionBg,
    introductionText,
    educationValue,
    cooperationModelBg,
    cooperationModelText,
    cooperationFlow,
    contactUs,
    recentNews = [],
    storyClassName = "",
    storyName = "",
    storyData = [],
    location,
  } = props
  return (
    <div data-role={pageType}>
      <Banner description={introductionText.describe}>
        {introductionText.title}
      </Banner>
      {/*<Introduction*/}
      {/*  introductionBg={introductionBg}*/}
      {/*  introductionText={introductionText}*/}
      {/*/>*/}
      <EducationValue educationValue={educationValue} />
      <CooperationModel
        cooperationModelBg={cooperationModelBg}
        cooperationModelText={cooperationModelText}
      />
      <CooperationFlow cooperationFlow={cooperationFlow} />
      <ContactUs contactUs={contactUs} location={location} />
      {pageType === "lecturer" ? (
        <EducationStory
          className={storyClassName}
          title={storyName}
          storyData={storyData}
        />
      ) : (
        <RecentNews recentNews={recentNews} />
      )}
    </div>
  )
}

export default CampusEnterpriseCooperation
